// extracted by mini-css-extract-plugin
export default {"select":"CompanyDropdown_select__ib6EM"};